import { useState } from 'react'
import {
  List,
  Datagrid,
  Create,
  Edit,
  SimpleForm,
  DateField,
  TextInput,
  DateTimeInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  BooleanInput,
  required,
  SingleFieldList,
  ChipField,
  useRecordContext,
  ReferenceArrayField,
  FormDataConsumer,
  ImageInput,
} from 'react-admin'
import { Box, Chip, Typography } from '@material-ui/core'
import { formatLogo } from '../utils'
import moment from 'moment-timezone'
import Alert from '@mui/material/Alert'

const IdNews = (props) => {
  const record = useRecordContext()
  return (
    <Typography style={{ width: '15px', textAlign: 'center' }} variant="body2">
      {record.id}
    </Typography>
  )
}
const Description = (props) => {
  const record = useRecordContext()
  return (
    <>
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{ __html: record.description }}
      />
    </>
  )
}
const Copros = (props) => {
  const record = useRecordContext()
  const coprosItems = record?.copros || []
  const allCopros = record?.all_copros || false

  return (
    <>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          flexWrap: 'nowrap',
        }}
      >
        {allCopros && coprosItems.length === 0 ? (
          <Box>
            <Chip label="Toutes" />
          </Box>
        ) : (
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            {' '}
            <ReferenceArrayField
              label="Copropriétés"
              reference="copros"
              source="copros"
              perPage={1}
            >
              <SingleFieldList>
                <ChipField source="libelle" />
              </SingleFieldList>
            </ReferenceArrayField>
            {coprosItems.length > 1 && (
              <Chip label={`+${coprosItems.length - 1}`} size="small" />
            )}
          </Box>
        )}
      </Box>
    </>
  )
}

const ActiveState = () => {
  const record = useRecordContext()
  const displayActive = record.active ? 'Oui' : 'Non'
  return (
    <Typography style={{ width: '40px', textAlign: 'center' }} variant="body2">
      {displayActive}
    </Typography>
  )
}

const StoplightState = () => {
  const record = useRecordContext()
  const displayStoplight = record.spotlighted ? 'Oui' : 'Non'
  return (
    <Typography style={{ width: '55px', textAlign: 'center' }} variant="body2">
      {displayStoplight}
    </Typography>
  )
}

export const ListCoprosGeneralNews = (props) => {
  return (
    <List {...props} style={{ marginBottom: '50px' }}>
      <Datagrid rowClick={props.rowClick || 'edit'} bulkActionButtons={false}>
        <IdNews label="ID" />
        <Description label="DESCRIPTION" />
        <Copros label="COPROPRIETES" />
        <StoplightState label="A LA UNE" />
        <DateField
          source="published_at"
          label="DATE DE PUBLICATION"
          locales="fr-FR"
        />
        <DateField
          source="deleted_at"
          locales="fr-FR"
          label="DATE DE SUPPRESSION"
          style={{ textAlign: 'center' }}
        />
      </Datagrid>
    </List>
  )
}
const SelectCopros = (props) => {
  return (
    <AutocompleteArrayInput
      fullWidth
      optionValue="id"
      optionText="libelle"
      size="small"
    />
  )
}
const InfoNews = ({ setOpenHelp }) => {
  return (
    <Alert
      onClose={() => setOpenHelp(false)}
      severity="info"
      sx={{ marginBottom: '15px', width: 'calc(100% - 35px)' }}
    >
      Maximum 3 News peuvent être affichées simultanément par copropriété
    </Alert>
  )
}

const InfoDescription = ({ setOpenHelp }) => {
  return (
    <Alert
      onClose={() => setOpenHelp(false)}
      severity="info"
      sx={{ marginBottom: '15px', width: 'calc(100% - 35px)' }}
    >
      Pour la description, vous pouvez uniquement utiliser ces balises HTML :
      <br />
      &lt;b&gt; <b>Texte en gras</b> &lt;/b&gt;
      <br />
      &lt;a href="url" target="_blank"&gt;{' '}
      <a href="" target="_blank">
        Exemple lien
      </a>{' '}
      &lt;/a&gt;
    </Alert>
  )
}

const sanitizeHtml = (input) => {
  const allowedTags = ['a', 'b']
  let sanitized = input.replace(
    /<\/?([a-z][a-z0-9]*)\b[^>]*>?/gi,
    (all, name) => {
      return allowedTags.includes(name) ? all : ''
    }
  )

  const stripped = sanitized.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>?/gi, '')
  if (stripped.length > 250) {
    return stripped.substring(0, 250)
  }

  return sanitized
}

const transformData = async (data) => {
  if (data.image) {
    if (!Array.isArray(data.image)) {
      data.image = [data.image]
    }
    data.image = data.image.filter((f) => f.src !== undefined)

    const promises = data.image.map((f) => {
      return new Promise((resolve, reject) => {
        if (f.rawFile instanceof Blob) {
          const reader = new FileReader()
          reader.readAsDataURL(f.rawFile)
          reader.onloadend = () => {
            f.base64 = reader.result.split(',')[1]
            resolve()
          }
          reader.onerror = (err) => {
            reject(err)
          }
        } else {
          resolve()
        }
      })
    })
    await Promise.all(promises)
  }

  if (data.description) {
    data.description = sanitizeHtml(data.description)
  }

  return data
}

export const CreateCoprosGeneralNews = (props) => {
  const currentDate = moment().format('YYYY-MM-DDThh:mm')
  const [openHelp, setOpenHelp] = useState(true)

  return (
    <Create {...props} transform={transformData}>
      <SimpleForm
        redirect={false}
        defaultValues={{ spotlighted: false, all_copros: false }}
      >
        {openHelp && <InfoNews setOpenHelp={setOpenHelp} />}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            flexWrap: 'wrap',
            gridColumnGap: '10px',
          }}
        >
          <DateTimeInput
            fullWidth
            source="published_at"
            label="Date de publication"
            helperText={false}
            validate={[required()]}
            sx={{
              flex: 1,
            }}
          />
          <DateTimeInput
            fullWidth
            source="deleted_at"
            label="Date de suppression"
            helperText={false}
            sx={{
              flex: 1,
            }}
            inputProps={{
              min: currentDate,
            }}
          />
        </Box>
        <Box sx={{ display: 'flex' }}>
          <BooleanInput label="A la une" source="spotlighted" />
          <BooleanInput label="Toutes les copropriétés" source="all_copros" />
        </Box>

        <FormDataConsumer>
          {({ formData }) => {
            if (!formData.all_copros) {
              return (
                <ReferenceArrayInput
                  label="Copropriétés"
                  source="copros_ids"
                  reference="copros"
                  validate={[required()]}
                >
                  <SelectCopros />
                </ReferenceArrayInput>
              )
            } else {
              return <></>
            }
          }}
        </FormDataConsumer>

        {openHelp && <InfoDescription setOpenHelp={setOpenHelp} />}

        <TextInput
          fullWidth
          multiline={true}
          source={'description'}
          label={'Description: 250 caractères maximum'}
          validate={[required()]}
        />
        <div
          style={{
            border: '1px solid #2b2b2b',
            borderRadius: '5px',
            marginTop: '8px',
            width: '100%',
          }}
        >
          <ImageInput
            label=" "
            source="image"
            accept="image/*"
            maxSize={5000000}
            format={formatLogo}
            fullWidth
            placeholder={
              <div style={{ color: '#2b2b2b' }}>
                Déposez l'image à uploader, ou cliquer pour le sélectionner.
              </div>
            }
          >
            <MyFileField fullWidth source="src" title="title" />
          </ImageInput>
        </div>
      </SimpleForm>
    </Create>
  )
}

export const EditCoprosGeneralNews = (props) => {
  return (
    <Edit {...props} transform={transformData}>
      <EditForm></EditForm>
    </Edit>
  )
}

const EditForm = () => {
  const record = useRecordContext()
  const currentDate = moment.tz('Europe/Paris').format('YYYY-MM-DDTHH:mm')
  const [openHelp, setOpenHelp] = useState(true)

  return (
    <SimpleForm
      style={{ padding: '0 20px' }}
      redirect={false}
      defaultValues={{ spotlighted: false, all_copros: false }}
    >
      {openHelp && <InfoNews setOpenHelp={setOpenHelp} />}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          flexWrap: 'wrap',
          gridColumnGap: '10px',
        }}
      >
        <DateTimeInput
          fullWidth
          source="published_at"
          label="Date de publication"
          helperText={false}
          validate={[required()]}
          sx={{
            flex: 1,
          }}
        />
        <DateTimeInput
          fullWidth
          source="deleted_at"
          label="Date de suppression"
          helperText={false}
          sx={{
            flex: 1,
          }}
          inputProps={{
            min: currentDate,
          }}
        />
      </Box>
      <Box sx={{ display: 'flex' }}>
        <BooleanInput label="A la une" source="spotlighted" />
        <BooleanInput label="Toutes les copropriétés" source="all_copros" />
      </Box>
      <FormDataConsumer>
        {({ formData }) => {
          if (!formData.all_copros) {
            return (
              <ReferenceArrayInput
                label="Copropriétés"
                source="copros_ids"
                reference="copros"
                validate={[required()]}
              >
                <SelectCopros />
              </ReferenceArrayInput>
            )
          } else {
            formData.copros_ids = null
            return <></>
          }
        }}
      </FormDataConsumer>

      {openHelp && <InfoDescription setOpenHelp={setOpenHelp} />}

      <TextInput
        fullWidth
        multiline={true}
        source={'description'}
        label={'Description: 250 caractères maximum'}
        validate={[required()]}
      />
      <div
        style={{
          border: '1px solid #2b2b2b',
          borderRadius: '5px',
          marginTop: '8px',
          width: '100%',
        }}
      >
        <ImageInput
          label=" "
          source="image"
          accept="image/*,.pdf"
          maxSize={5000000}
          format={formatLogo}
          fullWidth
          placeholder={
            <div style={{ color: '#2b2b2b' }}>
              Déposez l'image à uploader, ou cliquer pour le sélectionner.
            </div>
          }
        >
          <MyFileField fullWidth source="src" title="title" />
        </ImageInput>
      </div>
    </SimpleForm>
  )
}

const FilePreview = ({ record, source }) => {
  if (!record['rawFile']) return null
  const fileUrl = record[source]
  const fileType = record?.['rawFile']?.['name']?.split('.')?.pop()
  if (fileType === 'pdf') {
    return (
      <object data={fileUrl} type="application/pdf" width="250px">
        <p>Preview not available</p>
      </object>
    )
  }

  if (
    fileType === 'jpg' ||
    fileType === 'jpeg' ||
    fileType === 'png' ||
    fileType === 'gif'
  ) {
    return <img src={fileUrl} alt="preview" style={{ maxWidth: '250px' }} />
  }

  return <p>Preview not available</p>
}

const MyFileField = (props) => (
  <FilePreview record={props.record} source="src" />
)
